import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TNKAuthLoanFormComponent } from './auth-loan-form.component';
import { TNKAuthLoanFormService } from './auth-loan-form.service';
import { TNKDateDropdownModule } from '../../components/date-dropdown/date-dropdown.module';
import { TNKUtilitiesModule } from '../../utils/utilities.module';
import { ApiConstant } from '../../utils/api-constant/api-constant.service';
import { TNKLoanSliderModule } from '../../components/loan-slider/loan-slider.module';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { PlatformService } from '../../services/platform.services';

import { ModalModule } from '../../components/tnk-modal/modal.module';
export class TNKAuthLoanFormModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TNKUtilitiesModule,
    TNKLoanSliderModule,
    RouterModule,
    CurrencyMaskModule,
    TNKDateDropdownModule,
    ModalModule,
  ],
  declarations: [TNKAuthLoanFormComponent],
  exports: [TNKAuthLoanFormComponent],
  providers: [TNKAuthLoanFormService, ApiConstant, PlatformService],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TNKAuthLoanFormModule_tsickle_Closure_declarations() {
/** @type {?} */
TNKAuthLoanFormModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKAuthLoanFormModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
